/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Clear_ButtonInputs */

const en_chat_clear_button = /** @type {(inputs: Chat_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear history`)
};

const fr_chat_clear_button = /** @type {(inputs: Chat_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer l'historique`)
};

const ms_sg2_chat_clear_button = /** @type {(inputs: Chat_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padam sejarah`)
};

/**
* | output |
* | --- |
* | "Clear history" |
*
* @param {Chat_Clear_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_clear_button = /** @type {((inputs?: Chat_Clear_ButtonInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Clear_ButtonInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_clear_button(inputs)
	if (locale === "fr") return fr_chat_clear_button(inputs)
	return ms_sg2_chat_clear_button(inputs)
});